import React from 'react';
import { toLocaleString } from '../../../../../collums-components/helpers';
import { materialTableCurrencySorter } from '../../../../../utils/helpers/reports';

const columns = [
    { title: 'Staff', field: 'practitioner' },
    {
        title: 'Clients',
        field: 'clientsGroup',
        type: 'group',
        subColumns: [
            { title: '#', field: 'totalClients', type: 'quantity' },
            { title: 'New', field: 'newClients', type: 'quantity' }
        ],
        renders: [data => <span>{data.totalClients}</span>, data => <span>{data.newClients}</span>]
    },
    {
        title: 'Services',
        field: 'servicesGroup',
        type: 'group',
        subColumns: [
            { title: '#', field: 'servicesQuantity', type: 'quantity' },
            {
                title: 'Total',
                field: 'totalUnredemeedServices',
                customSort: (a, b, direction) => materialTableCurrencySorter(a, b, direction, 'servicesValue'),
                type: 'currency'
            }
        ],
        renders: [
            data => <span>{data.servicesQuantity}</span>,
            data => (
                <span style={data.totalUnredemeedServices < 0 ? { color: 'red' } : {}}>
                    {toLocaleString(data.totalUnredemeedServices)}
                </span>
            )
        ]
    },
    {
        title: 'Courses Sold',
        field: 'coursesSoldGroup',
        type: 'group',
        subColumns: [
            { title: '#', field: 'coursesQuantity', type: 'quantity' },
            {
                title: 'Total',
                field: 'totalCourses',
                customSort: (a, b, direction) => materialTableCurrencySorter(a, b, direction, 'totalCourses'),
                type: 'currency'
            }
        ],
        renders: [
            data => <span>{data.coursesQuantity}</span>,
            data => (
                <span style={data.totalCourses < 0 ? { color: 'red' } : {}}>{toLocaleString(data.totalCourses)}</span>
            )
        ]
    },
    {
        title: 'Products',
        field: 'productsGroup',
        type: 'group',
        subColumns: [
            { title: '#', field: 'productsQuantity', type: 'quantity' },
            {
                title: 'Total',
                field: 'totalProducts',
                customSort: (a, b, direction) => materialTableCurrencySorter(a, b, direction, 'totalProducts'),
                type: 'currency'
            }
        ],
        renders: [
            data => <span>{data.productsQuantity}</span>,
            data => (
                <span style={data.totalProducts < 0 ? { color: 'red' } : {}}>{toLocaleString(data.totalProducts)}</span>
            )
        ]
    },
    {
        title: 'Total Sales',
        field: 'totalSalesGroup',
        type: 'group',
        subColumns: [
            { title: '#', field: 'totalSaleQuantity', type: 'quantity' },
            {
                title: 'Total',
                field: 'totalSale',
                customSort: (a, b, direction) => materialTableCurrencySorter(a, b, direction, 'totalSale'),
                type: 'currency'
            }
        ],
        renders: [
            data => <span>{data.totalSaleQuantity}</span>,
            data => <span style={data.totalSale < 0 ? { color: 'red' } : {}}>{toLocaleString(data.totalSale)}</span>
        ]
    },
    {
        title: 'Courses Redemptions',
        field: 'coursesPerfGroup',
        type: 'group',
        subColumns: [
            { title: '#', field: 'redeemedQuantity', type: 'quantity' },
            {
                title: 'Total',
                field: 'totalRedeemed',
                customSort: (a, b, direction) => materialTableCurrencySorter(a, b, direction, 'redeemedValue'),
                type: 'currency'
            }
        ],
        renders: [
            data => <span>{data.redeemedQuantity}</span>,
            data => (
                <span style={data.redeemedValue < 0 ? { color: 'red' } : {}}>{toLocaleString(data.totalRedeemed)}</span>
            )
        ]
    },
    {
        title: 'Sales + Redemption',
        field: 'salesPerfGroup',
        type: 'group',
        subColumns: [
            {
                title: 'Total',
                field: 'total',
                customSort: (a, b, direction) => materialTableCurrencySorter(a, b, direction, 'total'),
                type: 'currency'
            }
        ],
        renders: [data => <span style={data.total < 0 ? { color: 'red' } : {}}>{toLocaleString(data.total)}</span>]
    }
];

export default columns;
